import doNothing from '@opsbase/lib-general/utils/doNothing';
import i18n from '@opsbase/lib-i18n';
import Palette from '@opsbase/lib-palette';
import useSelf from '@opsbase/react-ctrl-self/useSelf';
import useOrgFindById from '@opsbase/react-gql-hooks/organisation/useOrgFindById';
import useOrgResetAPIToken from '@opsbase/react-gql-hooks/organisation/useOrgResetAPIToken';
import markdown from '@opsbase/react-markdown';
import AppPage from '@opsbase/web-app/AppPage';
import useCss from '@opsbase/web-css';
import Card from '@opsbase/web-layout/Card';
import Pane from '@opsbase/web-layout/Pane';
import Vertical from '@opsbase/web-layout/Vertical';
import useNotificationActions from '@opsbase/web-notification/useNotificationActions';
import Button from '@opsbase/web-ui/Button';
import Text from '@opsbase/web-ui/Text';
import React, { useCallback } from 'react';
const makeMyClasses = () => ({
    apikey: {
        border: `1px solid ${Palette.BorderGrey.main}`,
        borderRadius: 4,
        fontSize: 12,
        backgroundColor: Palette.WhiteSmoke.main,
        overflow: 'hidden',
        wordWrap: 'break-word',
    },
});
export function AdvancedIntegrationsAPIPage() {
    const self = useSelf();
    const { loading, data, refetch } = useOrgFindById({ variables: { id: self.organisationId } });
    const org = data;
    const resetOrgAPIKey = useOrgResetAPIToken();
    const myCss = useCss(makeMyClasses);
    const { raise } = useNotificationActions();
    const handleClickReset = useCallback(() => {
        raise(resetOrgAPIKey({ id: self.organisationId }), i18n.t('api-reset-successfully'))
            .then(refetch)
            .catch(doNothing);
    }, [refetch, raise, resetOrgAPIKey, self]);
    return (React.createElement(AppPage, { busy: loading },
        React.createElement(Vertical, { gutter: true, padding: true, style: { overflow: 'auto', maxWidth: 700 } },
            React.createElement(Card, { padding: true },
                React.createElement(Vertical, { gutter: true },
                    !!(org === null || org === void 0 ? void 0 : org.apiToken) && (React.createElement(Pane, { grow: true, padding: true, classes: { root: myCss.apikey } }, org === null || org === void 0 ? void 0 : org.apiToken)),
                    React.createElement(Button, { label: (org === null || org === void 0 ? void 0 : org.apiToken)
                            ? i18n.t('api-token-reset')
                            : i18n.t('api-token-generate'), onClick: handleClickReset }),
                    React.createElement(Text, null, markdown(i18n.t('api-token-doclink'))))))));
}
export default AdvancedIntegrationsAPIPage;
